import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MeetingNotesURLsService {
  private readonly baseURL = '/api/meeting-notes';
  private readonly userBaseURL = '/api/meeting-notes/user';

  constructor() {}

  createMeetingNoteurl() {
    return this.baseURL;
  }

  getAllNotesById(userId: string, year: string): string {
    return `${this.baseURL}?userId=${userId}&year=${year}`;
  }

  deleteNoteById(id) {
    return this.baseURL + '/' + id;
  }

  updateNoteById(id) {
    return this.baseURL + '/' + id;
  }

  getNoteById(id) {
    return this.baseURL + '/' + id;
  }

  getAllmeetingNotesForUser(year) {
    return this.userBaseURL + '/' + year;
  }
}
